import jwtDecode from "jwt-decode";

class TokenManager {
    constructor() {
        this.getTokenFunction = null;
        this.inFlight = null;
        this.minTtlSeconds = 90;
    }

    setTokenProvider(getTokenFn) {
        this.getTokenFunction = getTokenFn;
    }

    async getToken() {
        if (!this.getTokenFunction) return null;
        if (this.inFlight) return this.inFlight;

        this.inFlight = (async () => {
            try {
                let token = await this.getTokenFunction({});
                const decoded = jwtDecode(token || '');
                const exp = Number(decoded.exp) || 0;
                const now = Math.floor(Date.now() / 1000);
                const ttl = exp - now;
                if (ttl <= this.minTtlSeconds) {
                    token = await this.getTokenFunction({ ignoreCache: true });
                }
                return token ?? null;
            } catch (error) {
                console.error("Error fetching token:", error);
                return null;
            } finally {
                this.inFlight = null;
            }
        })();

        return this.inFlight;
    }
}

const tokenManager = new TokenManager();
export default tokenManager;
